import store from '@/store'
export default {
  install(Vue) {
    Vue.prototype.$request = {

      // function GET
      get: async function (endpoint) {
        await this.isAuthorized(endpoint);
        store.commit("setProgressLinear", true);
        return new Promise((resolve, reject) => {
          Vue.prototype.$axios.get(endpoint)
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            })
        });
      },

      // function POST
      post: async function (endpoint, body) {
        store.commit("setProgressLinear", true);
        return new Promise((resolve, reject) => {
          Vue.prototype.$axios.post(endpoint,
            Vue.prototype.$formdata(body))
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            })
        });
      },

    }
  }
}